import { db } from '../config/firebase';

async function retrieveAll () {
  let query = db.collection( "clients" ).orderBy('order', 'asc');

  const querySnapshot = await query.get();

  let results = [];
  querySnapshot.forEach( doc => {
    results.push( {
      id: doc.id,
      ...doc.data()
    } );
  } );

  return results;
}

async function retrieveActive () {
  let query = db.collection( "clients" )
    .where("isActive", "==", true)
    .orderBy( 'order', 'asc' );

  const querySnapshot = await query.get();

  let results = [];
  querySnapshot.forEach( doc => {
    results.push( {
      id: doc.id,
      ...doc.data()
    } );
  } );

  return results;
}

export default {
  retrieveAll,
  retrieveActive
};